import { BehaviorSubject } from 'rxjs';
import { fromPromise } from 'rxjs/internal-compatibility';
import { take } from 'rxjs/operators';
import { appConfig } from '../../request/app.config';
import { courierService } from '../../request/services/courier.service';
import { GlobalAction } from '../interfaces/allowed-actions';

export interface AllowedAction {
  type: string;
  display_name: string;
  description: string;
  is_disabled: boolean;
  disabled_reason: string;
}

export class AllowedActionsService {
  private allowedActionsUrl: string;

  private allowedActionsSubject$ = new BehaviorSubject<AllowedAction[] | null>(null);

  constructor() {
    this.allowedActionsUrl = appConfig.getAllowedActionsURL();
  }

  getAllowedActions(forceRefresh = false, handleUnauthorisedResponse = false) {
    if (!forceRefresh && this.allowedActionsSubject$.getValue()) {
      return this.allowedActionsSubject$.pipe(take(1));
    }

    const options = {
      uiOptions: {
        handleUnauthorisedResponse,
        showLoading: false,
        showErrorMsg: false
      }
    };

    return fromPromise(
      courierService.get(this.allowedActionsUrl, options).then(res => {
        this.allowedActionsSubject$.next(res.data?.actions || []);
        return this.allowedActionsSubject$.getValue();
      })
    );
  }

  getActionByType(type: GlobalAction) {
    const actions = this.allowedActionsSubject$.getValue() ?? [];
    return actions.find(action => action.type === type);
  }
}

// eslint-disable-next-line import/no-mutable-exports
export let allowedActionsService = new AllowedActionsService();

export const setAllowedActionsService = (service: AllowedActionsService) => {
  allowedActionsService = service;
};
